import { translationKeys } from "../app-translation-keys";
import { ILanguageOption } from "../interfaces/language-options.interface";
import { LanguageOptionsEnum } from "./app-language-options.const";

const outputLanguageOptionsSubset: LanguageOptionsEnum[] = ["de", "en", "fr"] as const;

export const outputLanguageOptions: ILanguageOption[] = Object.values(outputLanguageOptionsSubset).map(code => ({
  name: code.toUpperCase(),
  labelKey: (translationKeys.languages as any)[code],
  code,
}));
